export var MenuTypes;

(function (MenuTypes) {
  MenuTypes["AboutMenu"] = "about-mega-menu";
  MenuTypes["AccountSideMenu"] = "account-side-menu";
  MenuTypes["BurgerMenu"] = "burger-menu";
  MenuTypes["FavoritesSideMenu"] = "favorites-side-menu";
  MenuTypes["JoinMenu"] = "join-mega-menu";
  MenuTypes["Minibag"] = "mini-bag";
  MenuTypes["Notifications"] = "notifications";
  MenuTypes["SearchInput"] = "search-input";
  MenuTypes["SearchResults"] = "search-results";
  MenuTypes["VipOrder"] = "vip-order";
})(MenuTypes || (MenuTypes = {}));

export var Name = 'toggle-menu-flyout';
export var ToggleFavorite = Name;